/**
 * Lawyer Seat Map page
 * Uses shared SeatMapViewer component
 */
import { createRoute, useSearch } from '@tanstack/react-router'
import { lawyerRoute } from './index'
import { SeatMapViewer, validateSeatMapSearch } from '@/components/amadeus'

function SeatMapPage() {
  const searchParams = useSearch({ from: '/lawyer/seatmap' })

  return (
    <div className="h-full flex flex-col p-6 lg:p-8">
      <SeatMapViewer
        searchParams={searchParams}
        activeButtonClass="bg-action-500"
      />
    </div>
  )
}

export const lawyerSeatMapRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/seatmap',
  component: SeatMapPage,
  validateSearch: validateSeatMapSearch,
})
